var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.refresh
    ? _c("BjGraph", {
        ref: "BjGraph",
        attrs: {
          api: _vm.api,
          "edge-text": "",
          "click-edge": _vm.hasPermissionBtn,
          movable: _vm.hasPermissionBtn,
          "only-ratio-virtual": "",
        },
        on: { refresh: _vm.refreshData },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }